module.exports = __webpack_public_path__ + "img/screen-users.0de75718.svg";